import { BrowserRouter, Routes, Route, useLocation, Navigate, Outlet } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './App.css';

import LoginLogistics from "./Auth/LoginLogistics";
import Header from "./Header/Header";
import ClientTask from "./Client/ClientTask";
import ClientDashboard from "./Client/ClientDashboard";
import LogisticsDashboard from "./Logistics/LogisticsDashboard";
import LogisticsTask from "./Logistics/LogisticsTask";
import OperationTask from "./Operation/OperationTask";
import OperationDashboard from "./Operation/OperationDashboard";
import LogisticsLocation from "./Logistics/LogisticsLocation";
import MasterPage from "./Operation/MasterPage";
import ScheduleManager from "./Operation/ScheduleManager";
import PublicRoute from "./components/PublicRoute";

// 🔒 Protected Route Component
const ProtectedRoute = ({ allowedRoles }) => {
  const token = localStorage.getItem("token");
  const user = JSON.parse(localStorage.getItem("user"));

  if (!token || !user) {
    return <Navigate to="/" replace />;
  }

  if (!allowedRoles.includes(user.role)) {
    // redirect to correct dashboard if user tries to access another role’s page
    const redirectPath =
      user.role === "OPERATION"
        ? "/operation-dashboard"
        : user.role === "LOGISTIC"
        ? "/logistics-dashboard"
        : "/client-dashboard";

    return <Navigate to={redirectPath} replace />;
  }

  return <Outlet />;
};

function AppContent() {
  const location = useLocation();
  const hideHeader = location.pathname === "/";

  return (
    <>
      {!hideHeader && <Header />}

      <Routes>
        {/* Public (Login) route - blocked for logged-in users */}
        <Route element={<PublicRoute />}>
          <Route path="/" element={<LoginLogistics />} />
        </Route>

        {/* Operation routes - only OPERATION role */}
        <Route element={<ProtectedRoute allowedRoles={["OPERATION"]} />}>
          <Route path="/operation-dashboard" element={<OperationDashboard />} />
          <Route path="/master-page" element={<MasterPage />} />
          <Route path="/slot-master" element={<ScheduleManager />} />
          <Route path="/operation-task" element={<OperationTask />} />
        </Route>

        {/* Logistics routes - only LOGISTIC role */}
        <Route element={<ProtectedRoute allowedRoles={["LOGISTIC"]} />}>
          <Route path="/logistics-dashboard" element={<LogisticsDashboard />} />
          <Route path="/logistics-task" element={<LogisticsTask />} />
          <Route path="/logistics-location" element={<LogisticsLocation />} />
        </Route>

        {/* Client routes - only CLIENT role */}
        <Route element={<ProtectedRoute allowedRoles={["CLIENT"]} />}>
          <Route path="/client-dashboard" element={<ClientDashboard />} />
          <Route path="/client-task" element={<ClientTask />} />
        </Route>

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}


function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
